import { UPDATE_DOCUMENT_BY_TABLA } from "../utils/updateDocumentConfig";

export const updateDocuments = async (tabla, empresaType, id, data) => {
    try {
        const fn = typeof UPDATE_DOCUMENT_BY_TABLA[tabla] === "function"
        ? UPDATE_DOCUMENT_BY_TABLA[tabla]
        : UPDATE_DOCUMENT_BY_TABLA[tabla]?.[empresaType];

        if (!fn) throw new Error(`No se encontró función para ${tabla} y ${empresaType}`);

        await fn(id, data);
    } catch (error) {
        console.error("Error al actualizar documento:", error);
        throw error;
    }
};
